import Client from 'Api/Client';
import EndPoint from 'Api/EndPoint';

const endpoint = `${EndPoint.Host}/${EndPoint.Ledger}`;

export async function getAccountBookStatistics(data) {
  return await Client.get(`${endpoint}/statistics`, data, true);
}

export async function getAccountBookByFieldId(fieldId) {
  return await Client.get(`${endpoint}/${fieldId}`, {}, true);
}

export async function getAccountBookItem(fieldId, itemId) {
  return await Client.get(`${endpoint}/${fieldId}/item/${itemId}`, {}, true);
}

export async function postInitialInput(fieldId, data) {
  return await Client.post(`${endpoint}/${fieldId}/initialInput`, data, true);
}

export async function getLedgerConfig() {
  return await Client.get(`${endpoint}/config`, {}, true);
}

export async function patchUserMetric(id, data) {
  return await Client.patch(`${endpoint}/${id}/userMetric`, data, true);
}

export async function postAccountBookSale(id, data) {
  return await Client.post(`${endpoint}/${id}/sale`, data, true);
}

export async function patchAccountBookSale(id, saleId, data) {
  return await Client.patch(`${endpoint}/${id}/sale/${saleId}`, data, true);
}

export async function deleteAccountBookSale(id, saleId) {
  return await Client.delete(`${endpoint}/${id}/sale/${saleId}`, {}, true);
}

export async function postAccountBookCollection(id, data) {
  return await Client.post(`${endpoint}/${id}/collection`, data, true);
}

export async function patchAccountBookCollection(id, collectionId, data) {
  return await Client.patch(`${endpoint}/${id}/collection/${collectionId}`, data, true);
}

export async function deleteAccountBookCollection(id, collectionId) {
  return await Client.delete(`${endpoint}/${id}/collection/${collectionId}`, {}, true);
}

export async function postAccountBookExpense(id, data) {
  return await Client.post(`${endpoint}/${id}/expense`, data, true);
}

export async function postAccountBookExpenseKey(id, data) {
  return await Client.post(`${endpoint}/${id}/expense/key`, data, true);
}

export async function patchAccountBookExpense(id, expenseId, data) {
  return await Client.patch(`${endpoint}/${id}/expense/${expenseId}`, data, true);
}

export async function patchAccountBookExpenseKey(id, expenseId, data) {
  return await Client.patch(`${endpoint}/${id}/expense/key/${expenseId}`, data, true);
}

export async function deleteAccountBookExpense(id, expenseId) {
  return await Client.delete(`${endpoint}/${id}/expense/${expenseId}`, {}, true);
}

export async function uploadLedgerImage(image, onProgress = null) {
  return await Client.uploadFile(`${endpoint}/uploadFile`, 'image', image, onProgress);
}

export async function downLoadExpenseByDateExcel(id) {
  return await Client.downLoadFile(`${endpoint}/${id}/expenseByDate/excel`, {}, true);
}

export async function downloadExpenseByCategoryExcel(id) {
  return await Client.downLoadFile(`${endpoint}/${id}/expenseByCategory/excel`, {}, true);
}

const fieldEndpoint = fieldId => `${endpoint}/field/${fieldId}`;

export async function patchUserMetricByFieldId(fieldId, data) {
  return await Client.patch(`${fieldEndpoint(fieldId)}/userMetric`, data, true);
}

export async function postAccountBookSaleByFieldId(fieldId, data) {
  return await Client.post(`${fieldEndpoint(fieldId)}/sale`, data, true);
}

export async function patchAccountBookSaleByFieldId(fieldId, saleId, data) {
  return await Client.patch(`${fieldEndpoint(fieldId)}/sale/${saleId}`, data, true);
}

export async function deleteAccountBookSaleByFieldId(fieldId, saleId) {
  return await Client.delete(`${fieldEndpoint(fieldId)}/sale/${saleId}`, {}, true);
}

export async function postAccountBookCollectionByFieldId(fieldId, data) {
  return await Client.post(`${fieldEndpoint(fieldId)}/collection`, data, true);
}

export async function patchAccountBookCollectionByFieldId(fieldId, collectionId, data) {
  return await Client.patch(`${fieldEndpoint(fieldId)}/collection/${collectionId}`, data, true);
}

export async function deleteAccountBookCollectionByFieldId(fieldId, collectionId) {
  return await Client.delete(`${fieldEndpoint(fieldId)}/collection/${collectionId}`, {}, true);
}

export async function postAccountBookExpenseKeyByFieldId(fieldId, data) {
  return await Client.post(`${fieldEndpoint(fieldId)}/expense/key`, data, true);
}

export async function patchAccountBookExpenseKeyByFieldId(fieldId, expenseId, data) {
  return await Client.patch(`${fieldEndpoint(fieldId)}/expense/key/${expenseId}`, data, true);
}

export async function deleteAccountBookExpenseByFieldId(fieldId, expenseId) {
  return await Client.delete(`${fieldEndpoint(fieldId)}/expense/${expenseId}`, {}, true);
}

export async function restoreAccountBookItemsByFieldId(fieldId, data) {
  return await Client.post(`${fieldEndpoint(fieldId)}/restore`, data, true);
}
